import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TrustpilotWidgetComponentDef } from './trustpilot-widget.component.def';

@Component({
    selector: 'trustpilot-widget',
    standalone: true,
    template: `
        <div #container class="trustpilot-widget flex flex-justify-center" [style.minHeight.px]="24">
            <a [attr.href]="url" target="_blank" rel="noopener">Trustpilot</a>
        </div>
    `,
    styles: [
        `
            .trustpilot-widget {
                visibility: hidden;
                &:has(iframe) {
                    visibility: visible;
                }
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrustpilotWidgetComponent extends TrustpilotWidgetComponentDef {}
